module.exports = __webpack_public_path__ + "gfx/WADC-1.png";